export const ProductsMap = {
    amex: 'amex'
}
